import React from 'react';
import withCopyright from 'hoc/withCopyright';

import { Box, Link, Paper } from '@mui/material';
import Container from '@mui/material/Container';
import Toolbar from '@mui/material/Toolbar';
import Typography from '@mui/material/Typography';

interface FooterProps {
  copyrightText: string;
}

const Footer: React.FunctionComponent<FooterProps> = ({ copyrightText }) => {
  return (
    <Paper sx={styles.paper} component='footer' square variant='outlined'>
      <Container maxWidth='lg'>
        <Box sx={styles.box}>
          <Toolbar>
            <Typography variant='overline'>
              {copyrightText}
              <Link
                href={process.env.REACT_APP_PORTFOLIO_V1}
                rel='noopener noreferrer'
                target='_blank'
              >
                Version 1.0
              </Link>
            </Typography>
          </Toolbar>
        </Box>
      </Container>
    </Paper>
  );
};

const styles = {
  paper: {
    width: '100%',
    position: 'fixed',
    bottom: 0,
  },
  box: {
    flexGrow: 1,
    justifyContent: 'center',
    display: 'flex',
    my: { sm: 0, md: 1 },
  },
};

export default withCopyright(Footer);
